<template>
  <div style="margin: 0 24px 24px;">
    <el-descriptions title="客户信息" border :column="2" size="small">
      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="主人" >{{ userForm.name }}</el-descriptions-item>
      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="性别" >{{ userForm.sex == 1?'男':userForm.sex == 2?'女':'未知' }}</el-descriptions-item>
      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="手机号" >{{ userForm.phone }}</el-descriptions-item>
      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="门店" >{{ userForm.shopName}}</el-descriptions-item>
    </el-descriptions>
    <el-descriptions title="" border :column="2" size="small" style="margin-top: 24px;">
      <template #title>
        <p>消费编号：<span style="color: #3a8ee6">{{ proDetailForm.projectNo }}</span></p>
      </template>
      <template #extra>
        <div v-if="!editable">
          <span style="font-size: 12px; color: red;">当前角色没有该门店的编辑权限</span>
        </div>
        <div v-else>
          <el-button v-if="proDetailForm.editState == 0" type="primary" size="small" @click="editProjectDialog(proDetailForm.projectNo)">编辑</el-button>
          <span v-else style="font-size: 12px; color: red;">
<!--          {{proDetailForm.preBookId > 0?'*超过预约时间24小时后无法修改':'超过创建时间24小时后无法修改'}}-->
            *三天后无法修改
        </span>
        </div>
      </template>
      <el-descriptions-item label-class-name="my-label" class-name="my-item" label="服务宠物" :span="2">
        <div v-for="(item, index) of petList" :key="item.id">
          {{item.petBreedColorName}}（{{item.name}}）<span v-if="item.petAgeMonth">{{item.petAgeMonth.age}}岁{{item.petAgeMonth.month}}个月</span>（{{item.sex == 1?'弟弟':item.sex == 2?'妹妹':'未知'}}）
        </div>
      </el-descriptions-item>
      <el-descriptions-item v-if="proDetailForm.preBookId > 0" label-class-name="my-label-2" class-name="my-item" label="预约时间" :span="2">{{ proDetailForm.preDay }} {{ proDetailForm.preTime }}</el-descriptions-item>
      <el-descriptions-item label-class-name="my-label-2" class-name="my-item" label="创建时间" :span="2">{{ proDetailForm.createTime }}</el-descriptions-item>
      <el-descriptions-item label-class-name="my-label-2" class-name="my-item" label="消费项目" :span="2">{{ proDetailForm.content }}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>
import Dialog from "@/assets/js/dialog";
import EditPaymentDialog from "@/views/user/components/payment/EditPaymentDialog";
import Drawer from "@/assets/js/drawer";
import EditProjectDialog from "@/views/user/components/project/EditProjectDialog";

export default {
  name: "PayDetailDialog",
  props: {
    value: Object
  },
  data() {
    return {
      userForm: this.value.userForm,
      proDetailForm: this.value.proDetailForm,
      petList: [],
    }
  },

  computed: {
    editable() {
      // let state = true
      // let visibleShopList = JSON.parse(sessionStorage.getItem('visibleShopList'))
      // if(visibleShopList.every(item => item.id != this.proDetailForm.shopId)) {
      //   state = false
      // }
      // return state
      let state = false
      let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
      ownShopList.map(item => {
        if(item.id == this.proDetailForm.shopId && item.isEdit == 1) {
          state = true
        }
      })
      return state
    }
  },

  methods: {
    editProjectDialog(tradeNo) {
      Drawer.open({
        title: '消费编号：' + tradeNo,
        component: EditProjectDialog,
        data: {
          userForm: this.userForm,
          // userId: this.userForm.id,
          idx: 1,
          preBookId: this.proDetailForm.preBookId,
          proDetailForm: this.proDetailForm,
          checkList: this.proDetailForm.petIdList,
          width: 1000
        },
        confirm: (result) => {
          this.$emit("confirm");
        }
      })
    }
  },

  mounted() {
    for(let i=0; i<this.proDetailForm.petIdList.length; i++) {
      for(let j=0; j<this.userForm.petList.length; j++) {
        if(this.proDetailForm.petIdList[i] == this.userForm.petList[j].id) {
          this.petList.push(this.userForm.petList[j])
        }
      }
    }
  },
}
</script>

<style scoped>

</style>
